<template>
  <div>
    <el-dialog class="wp95 hp90" :model-value="openDaiKe" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">代课</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDaiKe', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="tiaoke_ul" style="display: flex;">
        <div class="tiaoke_li" v-for="(rqItem, rqIndex) in rqTableData" :key="rqIndex">
          <el-container>
            <el-main class="pt0 pl10 pr0 pb0">
              <table border="1" style="border-collapse: collapse; width: 100%;">
                <thead>
                  <tr align="center">
                    <th style="width: 50px;">节次</th>
                    <th v-for="(rqVal, rqV) in rqItem.listRiQi" :key="rqV">
                      <div v-if="rqV===0">
                        <p>星期一</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===1">
                        <p>星期二</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===2">
                        <p>星期三</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===3">
                        <p>星期四</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===4">
                        <p>星期五</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===5">
                        <p>星期六</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===6">
                        <p>星期日</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr align="center" v-if="!tableData[rqIndex]">
                    <td colspan="8">暂无数据</td>
                  </tr>
                  <tr v-for="(item, index) in tableData[rqIndex]" :key="index">
                    <td align="center">
                      <div style="width: 50px;">{{ item.jc }}</div>
                    </td>
                    <!-- [tkbz]调课标志: 0-正常，1-已调课，2-已代课 -->
                    <td align="center" v-for="(xqItem, xqIndex) in item.xqs" :key="xqIndex" :style="xqItem.kcs.length?'cursor: pointer;':'cursor:not-allowed'" @dblclick="xqItem.kcs.length?daiKeDbClick(xqItem):''">
                      <div class="neirong">
                      <div v-for="(kcItem, kcIndex) in xqItem.kcs" :key="kcIndex">
                        <el-popover v-if="kcItem.tkbz === 2" placement="right">
                          <template #reference>
                            <div>
                              <div class="yitiao mt5 mb5">
                                <div class="yitiao-icon">代</div>
                                <el-link class="yitiao-but" :underline="false" type="danger" @click="qingChu(rqIndex, index, xqIndex, xqItem.kcs)">删</el-link>
                              </div>
                              <p>{{ kcItem.bjmc }}</p>
                              <p>{{ kcItem.kcmc }}</p>
                              <p>{{ kcItem.jsxms }}</p>
                              <p>{{ kcItem.jxcdmcs }}</p>
                            </div>
                          </template>
                          <p style="text-align: center;">详情</p>
                          <div>
                            <p>代课教师：{{ kcItem.dkjsxm }}</p>
                          </div>
                        </el-popover>
                        <!-- [tkbz]调课标志: 0-正常，1-已调课，2-已代课 -->
                        <div v-else>
                          <div>
                            <p>{{ kcItem.bjmc }}</p>
                            <p>{{ kcItem.kcmc }}</p>
                            <p>{{ kcItem.jsxms }}</p>
                            <p>{{ kcItem.jxcdmcs }}</p>
                          </div>
                        </div>
                      </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-main>
          </el-container>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div>双击选择代课教师</div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openDaiKe', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <daike v-if="openDanTiao" v-model:openDanTiao="openDanTiao" :row="tcRow" @ReturnData="ReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { closeWindow, actionPost } from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo.js'
import daike from './daike'

const props = defineProps({
  openDaiKe: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDaiKe', 'ReturnData'])

const tcRow = ref({})
const kblx = ref(1) // 课表类型

const rqTableData = ref([]) // 表头日期
const tableData = ref([]) // 列表

const openDanTiao = ref(false) // 加载
const jiaZai = ref(false) // 加载

const thData = ref({}) // 调换

const row = ref()
const daiKeDbClick = (item) => {
  openDanTiao.value = true
  jskbrqData.value.forEach(element => {
    if (element.zc === item.zc) {
      element.listRiQi.forEach((val, v) => {
        if (v + 1 === item.xq) {
          item.rq = val
        }
      })
    }
  })
  tcRow.value = {
    xljskbid: item.kcs[0].id,
    dbgzid: row.value.dbgzid,
    jc: item.jc,
    rq: item.rq,
    xq: item.xq,
    zc: item.zc
  }
}

// 教师课表日期
const jskbrqData = ref([])
const initJiaoShiKeBiaoRiQi = () => {
  kblx.value = 1
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/jiaoshikebiaoriqi',
    data: { dbgzid: row.value.dbgzid }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      jskbrqData.value = res.data
      rqTableData.value = jskbrqData.value
      initJiaoShiKeBiaoList()
    } else {
      warningPrompt(res.message)
    }
  })
}
// 教师课表
const jiaoShiData = ref([])
const initJiaoShiKeBiaoList = () => {
  kblx.value = 1
  if (thData.value.btjc === null && thData.value.btrq === null && thData.value.btxq === null && thData.value.btzc === null) {
    thData.value = {}
  }
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/jiaoshikebiao',
    data: { dbgzid: row.value.dbgzid }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      res.data.forEach((element) => {
        element.forEach((val) => {
          val.xqs = [
            { zc: val.zc, xq: 1, jc: val.jc, kcs: [] },
            { zc: val.zc, xq: 2, jc: val.jc, kcs: [] },
            { zc: val.zc, xq: 3, jc: val.jc, kcs: [] },
            { zc: val.zc, xq: 4, jc: val.jc, kcs: [] },
            { zc: val.zc, xq: 5, jc: val.jc, kcs: [] },
            { zc: val.zc, xq: 6, jc: val.jc, kcs: [] },
            { zc: val.zc, xq: 7, jc: val.jc, kcs: [] }
          ]
          if (val.kcs.length) {
            val.kcs.forEach((item) => {
              val.xqs.forEach(kcItem => {
                if (item.xq === kcItem.xq) {
                  kcItem.kcs.push(item)
                }
              })
            })
          }
        })
      })
      res.data.forEach((element) => {
        element.map((item) => { delete item.kcs; return item })
      })
      jiaoShiData.value = res.data
      tableData.value = jiaoShiData.value
    } else {
      warningPrompt(res.message)
    }
  })
}
// 调换
const ReturnData = (item) => {
  const o = {
    url: '/api/v2/jiaowu/daikejilu/daike',
    data: { dkjsid: item.jsid, xljskbid: tcRow.value.xljskbid, dbgzid: tcRow.value.dbgzid, jc: tcRow.value.jc, rq: tcRow.value.rq, xq: tcRow.value.xq, zc: tcRow.value.zc }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      initJiaoShiKeBiaoList()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 移除
const qingChu = (rqIndex, index, xqIndex, kcs) => {
  const o = {
    url: '/api/v2/jiaowu/daikejilu/shanchudaike',
    data: { dbgzid: row.value.dbgzid, xljskbid: kcs[0].id }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      initJiaoShiKeBiaoList()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 保存代课
const submit = async () => {
  const o = {
    url: '/api/v2/jiaowu/daikejilu/baocundaike',
    data: { dbid: row.value.id, dbgzid: row.value.dbgzid }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openDaiKe', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openDaiKe,
  () => {
    if (props.openDaiKe) {
      row.value = props.row
      initJiaoShiKeBiaoRiQi()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.tiaoke_ul {
  // height: calc(100% - 50px);
  .tiaoke_li {
    height: 100%;
    overflow: auto;
    width: -webkit-fill-available;
    table[border]:not([border='0']):not([style*='border-color']) th,
    table[border]:not([border='0']):not([style*='border-color']) td {
      border-color: #ebeef5;
    }
    table:not([cellpadding]) th,
    table:not([cellpadding]) td {
      padding: 5px;
    }
    table {
      height: 100%;
      thead {
        height: 40px;
      }
      tbody {
        height: calc(100% - 40px);
        overflow: auto;
        border: 1px solid !important;
        .neirong {
          width: 100%;
          height: 100%;
          min-width: 100px;
          min-height: 100px;
          padding: 5px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
        }
        .yitiao {
          width: auto;
          display: flex;
          justify-content: space-between;
          .yitiao-icon {
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            border: 1px solid #ccc;
            border-radius: 50%;
          }
        }
      }
    }
    th {
      background-color: #e6f7ff;
      color: rgba(0, 0, 0, 0.88);
      height: 60px;
    }
    td {
      padding: 0 !important;
    }
    .ketiao {
      cursor: move;
      color: #fff;
      background-color: #67c23a;
    }
    .buketiao {
      cursor: not-allowed;
      color: #fff;
      background-color: #f56c6c;
    }
  }
}
</style>
